import { makeAutoObservable } from 'mobx'

class OptionsTableStore {
  optionsTable = []

  constructor() {
    makeAutoObservable(this)
  }
  setOptionsTable(value) {
    this.optionsTable = value
  }
}

export default OptionsTableStore
